import axios from "axios";
import axiosInstance from "../../../helpers/api";

const GRADER_SPLIT_URL = "https://grader.edutopiaonline.com/api/questions/split";

export const getAllQuestionsBank = (id) => {
    return axiosInstance.get(`/admin/bank_questions?chapter_id=${id}`);
};

export const editQuestionBank = (formData) => {
    return axiosInstance.post(`/admin/bank_questions/${formData.id}`, formData.formData);
};


export const createQuestionBank = (formData) => {
    return axiosInstance.post('/admin/bank_questions', formData);
};

export const deleteQuestionBank = (id) => {
    return axiosInstance.delete(`/admin/bank_questions/${id}`);
};

export const hardDeleteQuestionBank = (id) => {
    return axiosInstance.delete(`/admin/bank_questions/hard_delete/${id}`);
};

export const bookmarkQuestionBank = (id) => {
    return axiosInstance.get(`/admin/bank_questions/book_mark/${id}`);
};

export const getTopMissedQuestionsForAdmin = () => {
    return axiosInstance.get('/admin/bank_questions/top-missed-questions');
};

export const updateQuestionTags = (id, tags) => {
    return axiosInstance.put(`/admin/bank_questions/update-question-tags/${id}`, { tags });
};

export const toggleMissedEnabled = (id) => {
    return axiosInstance.put(`/admin/bank_questions/toggle-missed-enabled/${id}`);
};

export const getGraderConfig = () => {
    return axiosInstance.get('/admin/bank_questions/grader_config');
};

/**
 * Upload PDF/image directly to grader (skips Laravel file hop).
 * Fetches API key from Laravel first (small JSON), then POSTs the file to grader.
 */
export const splitPdfQuestions = async (formData) => {
    const configRes = await getGraderConfig();
    const config = configRes?.data?.data || configRes?.data || {};
    const apiKey = config.api_key;
    const splitUrl = config.split_url || GRADER_SPLIT_URL;

    if (!apiKey) {
        throw new Error('Grader API key is not available');
    }

    return axios.post(splitUrl, formData, {
        headers: {
            'X-Api-Key': apiKey,
        },
        timeout: 180000,
    });
};

export const bulkCreateQuestionBank = (payload) => {
    return axiosInstance.post('/admin/bank_questions/bulk', payload);
};
